var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"my-24 lg:my-32"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }